import { render, staticRenderFns } from "./NewOrderNotification.vue?vue&type=template&id=30f59730&scoped=true"
import script from "./NewOrderNotification.vue?vue&type=script&lang=js"
export * from "./NewOrderNotification.vue?vue&type=script&lang=js"
import style0 from "./NewOrderNotification.vue?vue&type=style&index=0&id=30f59730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f59730",
  null
  
)

export default component.exports